import { createContext, useContext, useEffect, useState } from "react";
import { NATIVE_LANGUAGES, getNativeLanguage } from "../data/multiLanguage";

const NativeLanguageContext = createContext(null);

const STORAGE_KEY = "nativeLanguage";

export function NativeLanguageProvider({ children }) {
  const [code, setCode] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) return saved;
    // Auto-detect from browser locale
    const browserLang = (navigator.language || "en").split("-")[0];
    return NATIVE_LANGUAGES.find((l) => l.code === browserLang)?.code || "hi";
  });

  const [pickerOpen, setPickerOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, code);
  }, [code]);

  const language = getNativeLanguage(code);

  const value = {
    code,
    setCode,
    language,
    pickerOpen,
    openPicker: () => setPickerOpen(true),
    closePicker: () => setPickerOpen(false),
    languages: NATIVE_LANGUAGES,
  };

  return <NativeLanguageContext.Provider value={value}>{children}</NativeLanguageContext.Provider>;
}

export function useNativeLanguage() {
  const ctx = useContext(NativeLanguageContext);
  if (!ctx) throw new Error("useNativeLanguage must be used inside NativeLanguageProvider");
  return ctx;
}
